// extracted by mini-css-extract-plugin
export default {"ImageUploaderContainer":"📚19-10-2_H4Zl","ImageUploaderItem":"📚19-10-2Et600"};